import React, { useEffect, useState } from "react";
import PageTitle from "../components/PageTitle";
import SingleContentSection from "../components/Content/SingleContentSection";
import "./ProgramPage.css";
import { BlogEntryItem } from "../utils/types/BlogEntryItem";

const currentItemTitleProgram = "Môj program pre Púchov";
const ProgramPage: React.FC = () => {
    const [currentItemContent, setCurrentItemContent] = useState<string>("");
    const [currentItemTitle, setCurrentItemTitle] = useState<string>("");
    useEffect(() => {
        const data = localStorage.getItem("main-articles");
        if (data) {
            const items = JSON.parse(data) as BlogEntryItem[];
            const item = items.filter(i => (i.blog.category === "mainContent" && i.meta.url == "program"))[0];
            if (item) {
                setCurrentItemContent(item.blog.content);
                setCurrentItemTitle(item.blog.title);
            }
        }
    })
    return (
        <div>
            <PageTitle pageName="" desc="" id="program"/>
            <SingleContentSection title={currentItemTitle} text={currentItemContent} itemUrl="program" />
        </div>
    )
}

export default ProgramPage;